import { type ReactNode } from 'react'
import { Icon, type IconName } from '../icons/Icon'

/**
 * Sidenav の 1 行。design/js/components.jsx:39-44 と同じ DOM 構造。
 * badge は数値 / 文字列どちらも受ける (例: 保管庫の件数)。null/undefined で非表示。
 */
export interface NavItemProps {
  icon: IconName
  label: string
  active?: boolean
  badge?: ReactNode
  onClick?: () => void
}

export const NavItem = ({ icon, label, active, badge, onClick }: NavItemProps): JSX.Element => (
  <button
    type="button"
    className={`nav-item${active ? ' active' : ''}`}
    onClick={onClick}
    title={label}
  >
    <span className="ico">
      <Icon name={icon} />
    </span>
    <span className="lbl">{label}</span>
    {badge != null && <span className="badge">{badge}</span>}
  </button>
)
